import { render } from "./harvester.vue?vue&type=template&id=a96422c4"
import script from "./harvester.vue?vue&type=script&lang=js"
export * from "./harvester.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__